// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CNtx","top":"styles_top__1BsLd"};